import React, { useState } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CustomInput,
  Row,
  Col
} from 'reactstrap'
import _ from 'lodash'
import Moment from 'moment'
import { connect } from 'react-redux'

import MultiLangInput from 'components/Input/MultiLang'
import MultiLangRTE from 'components/RTE/MultiLang'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import MediaDatabase from 'SharedModules/MediaDatabase'
import { toggleMediaDatabase } from 'actions/MediaDatabaseToggle'

import Lang from 'Lang/General'

const Update = props => {
  const [ countryId, updateCountryId ] = useState( 0 )
  const [ centerGroupId, updateCenterGroupId ] = useState( 0 )

  const onChangeNewsData = ( key, val ) => {
    let tmp = _.cloneDeep( props.selectedNews )
    tmp[ key ] = val
    return props.onChangeNewsHOC( 'selectedNews', tmp )
  }

  return (
    <Modal
      isOpen={ props.showUpdateNews }
      toggle={() => {
        props.onChangeNewsHOC( 'showUpdateNews', false )
      }}
      size={ 'lg' }>
      <ModalHeader toggle={() => props.onChangeNewsHOC( 'showUpdateNews', false )}>{ Lang[ 'UPDATE_NEWS' ][ props.data.languageReducer.lang ] }</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <MultiLangInput
              label={ Lang[ 'NAME' ][ props.data.languageReducer.lang ] }
              selectedLanguage={ props.data.languageReducer.lang }
              value={ props.selectedNews.name }
              type={ 'text' }
              onChange={ val => {
                onChangeNewsData( 'name', val )
              }}/>
          </FormGroup>
          <FormGroup>
            <MultiLangRTE
              label={ Lang[ 'DESCRIPTION' ][ props.data.languageReducer.lang ] }
              selectedLanguage={ props.data.languageReducer.lang }
              value={ props.selectedNews.description }
              onChange={ val => {
                onChangeNewsData( 'description', val )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>{ Lang[ 'UPLOAD_IMAGE' ][ props.data.languageReducer.lang ] }</Label>
            <Input
              type="text"
              value={ props.selectedNews.image_url }
              onChange={ e => {
                onChangeNewsData( 'image_url', e.target.value )
              }}
              disabled={ true } />
            <Button
              color="primary"
              className="mt-2"
              onClick={() => {
                props.toggleMediaDatabase( true )
              }}>
            { Lang[ 'SELECT_IMAGE' ][ props.data.languageReducer.lang ] }</Button>
            <div className="mt-2">
              {
                props.selectedNews.image_url && <img src={ props.selectedNews.image_url } style={{ width: '30%' }} />
              }
            </div>
          </FormGroup>
          <FormGroup>
            <Label>{ Lang[ 'REDIRECT_URL' ][ props.data.languageReducer.lang ] }</Label>
            <Input
              type="text"
              value={ props.selectedNews.redirect_url }
              onChange={ e => {
                onChangeNewsData( 'redirect_url', e.target.value )
              }} />
          </FormGroup>
          <FormGroup>
            <Label>{ Lang[ 'PUBLISH_FROM' ][ props.data.languageReducer.lang ] }</Label>
            <Input
              type="date"
              value={ props.selectedNews.publish_from ? Moment( props.selectedNews.publish_from ).format( 'YYYY-MM-DD' ) : '' }
              onChange={ e => {
                let tmpDate = new Date( e.target.value )
                let tmpDateString = tmpDate.toISOString()
                onChangeNewsData( 'publish_from', tmpDate )
              }} />
          </FormGroup>
          <FormGroup>
            <CustomInput
              id='has_expiry_date'
              type='checkbox'
              label={ Lang[ 'HAS_EXPIRY_DATE' ][ props.data.languageReducer.lang ] }
              checked={ props.selectedNews.has_expiry_date }
              onChange={ e => onChangeNewsData( 'has_expiry_date', e.target.checked ) }/>
          </FormGroup>
          {
            props.selectedNews.has_expiry_date && (
              <FormGroup>
                <Label>{ Lang[ 'PUBLISH_TO' ][ props.data.languageReducer.lang ] }</Label>
                <Input
                  type="date"
                  value={ props.selectedNews.publish_to ? Moment( props.selectedNews.publish_to ).format( 'YYYY-MM-DD' ) : '' }
                  onChange={ e => {
                    let tmpDate = new Date( e.target.value )
                    let tmpDateString = tmpDate.toISOString()
                    onChangeNewsData( 'publish_to', tmpDate )
                  }} />
              </FormGroup>
            )
          }
          <FormGroup>
            <Label>{ Lang[ 'STATUS' ][ props.data.languageReducer.lang ] }</Label>
            <Input
              type="select"
              value={ props.selectedNews.status }
              onChange={ e => {
                onChangeNewsData( 'status', e.target.value )
              }}>
              <option>{ Lang[ 'SELECT_STATUS' ][ props.data.languageReducer.lang ] }</option>
              <option value="ACTIVE">ACTIVE</option>
              <option value="INACTIVE">INACTIVE</option>
            </Input>
          </FormGroup>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label>{ Lang[ 'SELECT_COUNTRIES' ][ props.data.languageReducer.lang ] }</Label>
                <Input
                  type="select"
                  value={ countryId }
                  onChange={ e => {
                    updateCountryId( parseInt( e.target.value, 10 ) )
                  }}>
                  <option></option>
                  {
                    props.countries.map( item => {
                      let tmpIndex = _.findIndex( props.selectedNews.countries, { id: item.id })
                      if( tmpIndex === -1 ) {
                        return (
                          <option key={ item.id } value={ item.id }>{ item.name }</option>
                        )
                      }
                    })
                  }
                </Input>
                <Button
                  color="primary"
                  onClick={() => {
                    if( countryId > 0 ) {
                      let tmpCountries = _.cloneDeep( props.selectedNews.countries )
                      let tmp = _.find( props.countries, { id: countryId })
                      tmpCountries.push( tmp )
                      onChangeNewsData( 'countries', tmpCountries )
                    }
                  }}>{ Lang[ 'ADD' ][ props.data.languageReducer.lang ] }</Button>
              </FormGroup>
              <FormGroup>
                {
                  props.selectedNews.countries.map( item => {
                    return (
                      <Card key={ item.id }>
                        <CardBody>
                          <Row>
                            <Col md={7}>
                              { item.name }
                            </Col>
                            <Col md={5}>
                              <Button
                                color="danger"
                                onClick={() => {
                                  let tmpCountries = _.cloneDeep( props.selectedNews.countries )
                                  _.remove( tmpCountries, { id: item.id })
                                  onChangeNewsData( 'countries', tmpCountries )
                                }}
                                className="ml-3">{ Lang[ 'DELETE' ][ props.data.languageReducer.lang ] }</Button>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    )
                  })
                }
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>{ Lang[ 'SELECT_CENTER_GROUPS' ][ props.data.languageReducer.lang ] }</Label>
                <Input
                  type="select"
                  value={ centerGroupId }
                  onChange={ e => {
                    updateCenterGroupId( parseInt( e.target.value, 10 ) )
                  }}>
                  <option></option>
                  {
                    props.centerGroupForSelect.map( item => {
                      let tmpIndex = props.selectedNews.center_group_ids.indexOf( item.id )
                      if( tmpIndex === -1 ) {
                        return (
                          <option key={ item.id } value={ item.id }>{ item.text }</option>
                        )
                      }
                    })
                  }
                </Input>
                <Button
                  color="primary"
                  onClick={() => {
                    if( centerGroupId > 0 ) {
                      let tmpCenterGroups = _.cloneDeep( props.selectedNews.center_group_ids )
                      let tmp = _.find( props.centerGroupForSelect, { id: centerGroupId })
                      tmpCenterGroups.push( tmp.id )
                      onChangeNewsData( 'center_group_ids', tmpCenterGroups )
                    }
                  }}>{ Lang[ 'ADD' ][ props.data.languageReducer.lang ] }</Button>
              </FormGroup>
              <FormGroup>
                {
                  props.selectedNews.center_group_ids.map( item => {
                    let tmp = _.find( props.centerGroupForSelect, { id: item })
                    if( tmp ) {
                      return (
                        <Card key={ item }>
                          <CardBody>
                            <Row>
                              <Col md={7}>
                                { tmp.text }
                              </Col>
                              <Col md={5}>
                                <Button
                                  color="danger"
                                  onClick={() => {
                                    let tmpCenterGroups = _.cloneDeep( props.selectedNews.center_group_ids )
                                    _.remove( tmpCenterGroups, val => val === item )
                                    onChangeNewsData( 'center_group_ids', tmpCenterGroups )
                                  }}
                                  className="ml-3">{ Lang[ 'DELETE' ][ props.data.languageReducer.lang ] }</Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      )
                    }
                  })
                }
              </FormGroup>
            </div>
          </div>
        </Form>
        <MediaDatabase
          onSelectedImage={( param ) => {
            onChangeNewsData( 'image_url', param )
            props.toggleMediaDatabase( false )
          }} />
        { props.onLoadNews && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            if( !props.selectedNews.has_expiry_date ) {
              delete props.selectedNews.publish_to
            }
            props.updateNews( props.selectedNews )
          }}>{ Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )
}
const mapStateToProps = state => ({ data: state })

export default connect( mapStateToProps, {
  toggleMediaDatabase
})( Update )
